import { render, staticRenderFns } from "./ProcList.vue?vue&type=template&id=72905a16&scoped=true&"
import script from "./ProcList.vue?vue&type=script&lang=js&"
export * from "./ProcList.vue?vue&type=script&lang=js&"
import style0 from "./ProcList.vue?vue&type=style&index=0&id=72905a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72905a16",
  null
  
)

export default component.exports